import {createSvgIcon} from '../create-svg-icon';

export const ExpandMoreIcon = createSvgIcon(
  <path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z" />
, 'ExpandMoreOutlined');
